export default __webpack_public_path__ + "static/media/editIcon.a753b12c.svg";